import React, { useEffect, useMemo, useState } from 'react'
import classes from "./PricingNewpayment.module.css";
import promix from "../../Assets/Promix.svg"
import deletes from "../../Assets/delete.svg"
import credtcrd from "../../Assets/Credit Card.png"
import wallet from "../../Assets/wallet-03.png"
import uploadFile from "../../Assets/uploadFile.svg"
import card from "../../Assets/credit-card-01.png"
import lock from "../../Assets/lock.png"
import arrowleft from "../../Assets/arrow-left.png"
import marked from "../../Assets/tick.png"
import star from "../../Assets/star.svg"
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import api, { withCompanyId } from "../../Components/API/Api";
import Swal from "sweetalert2";
import { useUser } from '../../UserContext';

const ManualOpeningBal = () => {
    const [showPaystackModal, setShowPaystackModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(true);
    const [showAcctModal, setShowAcctModal] = useState(false);
    const handleShowSuccessModal = () => setShowSuccessModal(true);
    const handleShowAcctModal = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };
    const handleCloseAcctModal = () => setShowAcctModal(false);
    const handleCloseSuccessModal = () => setShowSuccessModal(false);
    const [successSummary, setSuccessSummary] = useState(null);
    const [showDeclinedModal, setShowDeclinedModal] = useState(false);
    const [showAccountDetailsModal, setShowAccountDetailsModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("paystack");
    const [savingAccountsLoading, setSavingAccountsLoading] = useState(false);
    // Dummy wallet account details
    const [accountDetails, setAccountDetails] = useState({ accountName: 'Demo User', accountNumber: '9876543210', bank: 'DemoBank' });
    // Dummy wallet balance (set to 0 for insufficient funds test)
    const [walletBalance, setWalletBalance] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const [rows, setRows] = useState([
        { accountName: "", accountCode: "", description: "", debit: "", credit: "", showDropdown: false }
    ]);
    const [selectedDate, setSelectedDate] = useState('');   
    const [accountTypes, setAccountTypes] = useState([]);
    const [loadingTypes, setLoadingTypes] = useState(false);
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const { login, setActiveCompany } = useUser();
    const selectedPlan = location.state?.selectedPlan;
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [formData, setFormData] = useState([]);

    useEffect(() => {
        const companyId = location.state?.company_id;
        if (companyId) {
            localStorage.setItem("company_id", String(companyId));
            localStorage.setItem("activeCompanyId", String(companyId));
        }
    }, [location.state?.company_id]);

    const formatMonthlyPrice = (plan) => {
        if (!plan || plan.monthly == null) return "₦0";
        const value = parseFloat(plan.monthly);
        if (Number.isNaN(value)) return "₦0";
        return `₦${value.toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

      const removeRow = (index) => {
    setRows(prev => prev.length === 1 ? prev : prev.filter((_, i) => i !== index));
  };

//     const addLine = () => {
//     setRows(prev => [
//       ...prev,
//       { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false },
//     ]);
//   };

const addLine = () => {
  setRows(prev => [
    ...prev,
    {
      accountId: "",
      accountDisplay: "",
      description: "",
      debit: "",
      credit: "",
      showDropdown: false,
      isPrefilled: false, // 👈 user-added rows
    },
  ]);
};  




  const handleChange = (index, field, value) => {
    setRows(prev => {
      const newRows = [...prev];
      const row = { ...newRows[index] };
      if (field === "debit") {
        row.debit = value;
        if (parseFloat(value) > 0) row.credit = "0";
      } else if (field === "credit") {
        row.credit = value;
        if (parseFloat(value) > 0) row.debit = "0";
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else if (field === "showDropdown") {
        row.showDropdown = value;
      } else {
        row[field] = value;
      }
      newRows[index] = row;
      return newRows;
    });
  };

    const planName = selectedPlan?.name || "Professional";
    const planDescription = selectedPlan?.use || "For growing businesses and small teams";
    const planAmount = selectedPlan ? formatMonthlyPrice(selectedPlan) : "₦25,000";
    const planPrivileges = selectedPlan?.privileges || [
        "5 Users",
        "Advanced Reports",
        "Multi-currency",
        "API Access",
        "Priority Support",
        "Custom Integrations",
        "Automated Workflows",
    ];

      // Fetch accounts
      useEffect(() => {
        const fetchAccounts = async () => {
          const token = localStorage.getItem("authToken");
          if (!token) return;
          setAccountsLoading(true);
          try {
            const res = await api.get('/v1/account/company-accounts');
            let raw = res?.data?.data ?? res?.data ?? [];
            if (Array.isArray(raw.data)) raw = raw.data;
            setAccounts(Array.isArray(raw) ? raw : []);
          } catch (err) {
            console.error("Error fetching accounts:", err);
            setAccounts([]);
          } finally {
            setAccountsLoading(false);
          }
        };
        
        fetchAccounts();
    }, []);

        const token = localStorage.getItem("authToken");

        useEffect(() => {
            const fetchAccountTypes = async () => {
                try {
                    setLoadingTypes(true);

                    const resp = await api.get('/v1/get-sub-categories');

                    const raw = resp?.data?.data ?? resp?.data ?? [];
                    const list = Array.isArray(raw) ? raw : [];

                    setAccountTypes(list);
                } catch (e) {
                    console.error(
                        'Failed to load account types',
                        e?.response?.data || e?.message
                    );
                    setAccountTypes([]);
                } finally {
                    setLoadingTypes(false);
                }
            };

            fetchAccountTypes();
        }, [token]);      
    
      // Populate rows with accounts
    //   useEffect(() => {
    //     if (showAcctModal && accounts.length > 0) {
    //       setRows(accounts.map(acc => ({
    //         accountId: acc.id,
    //         accountName: acc.gl_name ?? acc.name ?? "",
    //         accountCode: acc.gl_code ?? acc.code ?? "",
    //         description: "",
    //         debit: "",
    //         credit: "",
    //         showDropdown: false
    //       })));
    //     }
    //   }, [showAcctModal, accounts]);

        useEffect(() => {
        if (accounts.length > 0) {
            setRows(
            accounts.map(acc => ({
                accountId: acc.id,
                accountName: acc.gl_name ?? acc.name ?? "",
                accountCode: "",
                description: acc.category.description ?? "",
                debit: "",
                credit: "",
                showDropdown: false,
                isPrefilled: true, // 👈 add this
            }))
            );
        }
        }, [accounts]);

    
        const saveNewAccountsOld = async () => {
            try {
                setSavingAccountsLoading(true);

                // get company_id
                const companyId =
                    location.state?.company_id ||
                    localStorage.getItem("company_id") ||
                    localStorage.getItem("activeCompanyId");

                if (!companyId) {
                    Swal.fire("Error", "Company ID not found", "error");
                    return;
                }

                // only newly added rows
                const newRows = rows.filter((row) => !row.isPrefilled);

                // if no new rows, just navigate
                if (newRows.length === 0) {
                    navigate("/dashboard");
                    return;
                }

                // validate rows
                const invalidRow = newRows.find(
                    (row) => !row.accountName || !row.accountCode
                );

                if (invalidRow) {
                    Swal.fire(
                        "Validation Error",
                        "All new rows must have account name and account type",
                        "warning"
                    );
                    return;
                }

                // format payload
                const payload = {
                    account_type: newRows.map((row) => row.accountCode),
                    account_name: newRows.map((row) => row.accountName),
                    company_id: companyId,
                };

                console.log("Payload:", payload);

                const response = await api.post(
                    "/v1/journal/opening-balance-bulk",
                    payload
                );

                if (
                    response?.data?.status === true ||
                    response?.data?.success === true
                ) {
                    Swal.fire(
                        "Success",
                        "Accounts created successfully",
                        "success"
                    );

                    navigate("/dashboard");
                } else {
                    Swal.fire(
                        "Error",
                        response?.data?.message || "Failed to save accounts",
                        "error"
                    );
                }
            } catch (error) {
                console.error(error);

                Swal.fire(
                    "Error",
                    error?.response?.data?.message ||
                        "Something went wrong",
                    "error"
                );
            } finally {
                setSavingAccountsLoading(false);
            }
        };

        const saveNewAccounts = async () => {
    try {
        const confirmed = await Swal.fire({
            title: "Are you sure?",
            text: "You are about to save opening balances.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#059669",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, save it!",
        });

        if (!confirmed.isConfirmed) return;

        setSavingAccountsLoading(true);

        // company id
        const companyId =
            location.state?.company_id ||
            localStorage.getItem("company_id") ||
            localStorage.getItem("activeCompanyId");

        if (!companyId) {
            Swal.fire("Error", "Company ID not found", "error");
            return;
        }

        // transaction date
        // const transactionDate = new Date().toISOString().split("T")[0];

        // only rows with amount
        const validRows = rows.filter(
            (row) =>
                row.credit &&
                row.credit !== "" &&
                parseFloat(row.credit) > 0
        );

        // if (validRows.length === 0) {
        //     Swal.fire(
        //         "Validation Error",
        //         "Please enter at least one opening balance",
        //         "warning"
        //     );
        //     return;
        // }

        // account ids
        const accountIds = validRows.map((row) => row.accountId);

        // amount array
        const amounts = validRows.map((row) =>
            parseFloat(row.credit).toFixed(2)
        );

        // direction array
        // credit = 2
        // debit = 1
        // const directions = validRows.map((row) =>
        //     row.accountCode === "credit" ? 2 : 1
        // );
        const directions = validRows.map((row) =>
            Number(row.accountCode)
        );
        // calculate totals
        let totalCredit = 0;
        let totalDebit = 0;

        validRows.forEach((row) => {
            const amount = parseFloat(row.credit || 0);
            if (row.accountCode == "2") {
                totalCredit += amount;
            } else if (row.accountCode == "1") {
                totalDebit += amount;
            }
        });

        const payload = {
            all_credit: totalCredit.toFixed(2),
            all_debit: totalDebit.toFixed(2),
            account_id: accountIds,
            direction: directions,
            transaction_date: selectedDate,
            amount: amounts,
            company_id: companyId,
        };

        console.log("Opening Balance Payload:", payload);

        const response = await api.post(
            "/v1/journal/opening-balance-bulk",
            payload
        );

        if (
            response?.data?.status === true ||
            response?.data?.success === true
        ) {
            Swal.fire(
                "Success",
                response?.data?.message ||
                    "Opening balances saved successfully",
                "success"
            );

            navigate("/dashboard");
        } else {
            Swal.fire(
                "Error",
                response?.data?.message ||
                    "Failed to save opening balances",
                "error"
            );
        }
    } catch (error) {
        console.error(error);

        Swal.fire(
            "Error",
            error?.response?.data?.message ||
                "Something went wrong",
            "error"
        );
    } finally {
        setSavingAccountsLoading(false);
    }
};
    

    // Ensure page is scrolled to top whenever this route is navigated to
    useEffect(() => {
        try {
            window.scrollTo(0, 0);
        } catch {
            // ignore if environment doesn't support window scrolling
        }
    }, [location.pathname]);

    // If Paystack redirects back after checkout, show the appropriate modal.
    useEffect(() => {
        // Merge search params and hash params (some gateways use hash fragments)
        const combined = new URLSearchParams(location.search || "");
        if (location.hash) {
            const hashString = location.hash.replace(/^#/, "");
            const hashParams = new URLSearchParams(hashString);
            for (const [k, v] of hashParams.entries()) {
                if (!combined.has(k)) combined.set(k, v);
            }
        }

        const status = (combined.get("status") || combined.get("payment_status") || "").toLowerCase();
        const successFlag = (combined.get("success") || combined.get("paid") || "").toLowerCase();
        const failedFlag = (combined.get("failed") || combined.get("cancelled") || "").toLowerCase();

        const isSuccessFromRedirect =
            status === "success" ||
            status === "successful" ||
            successFlag === "true" ||
            successFlag === "1" ||
            successFlag === "yes";

        const isFailedFromRedirect =
            status === "failed" ||
            status === "failure" ||
            status === "cancelled" ||
            status === "canceled" ||
            failedFlag === "true" ||
            failedFlag === "1" ||
            failedFlag === "yes";

        const referenceParam = combined.get("reference") || combined.get("trxref") || combined.get("tx_ref") || "";
        const treatReferenceAsSuccess = referenceParam && !isFailedFromRedirect;

        // Debug helpers to help during testing
        try {
            console.debug("Payment redirect params:", Object.fromEntries(combined.entries()));
        } catch {}

        if (isSuccessFromRedirect || treatReferenceAsSuccess) {
            console.log("Token after redirect:", localStorage.getItem("token"));
            let foundSummary = null;
            try {
                const raw = localStorage.getItem("pendingPaymentSummary");
                if (raw) foundSummary = JSON.parse(raw);
            } catch (err) {
                console.debug("Failed to read pendingPaymentSummary:", err);
            } finally {
                localStorage.removeItem("pendingPaymentSummary");
            }

            // Prefer explicit display values returned by the backend in query
            // params (so we can show a full summary even if localStorage was
            // cleared). Common keys: `plan`, `plan_name`, `amount`, `amountPaid`.
            const planFromQuery = combined.get('plan') || combined.get('plan_name') || '';
            const amountFromQuery = combined.get('amount') || combined.get('amountPaid') || combined.get('amount_paid') || '';

            const formatAmount = (val) => {
                if (!val) return planAmount;
                const n = Number(String(val).replace(/[^0-9.-]+/g, ''));
                if (Number.isFinite(n)) {
                    const naira = n / 100; // Convert from kobo to naira
                    return `₦${naira.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                }
                return String(val);
            };

            if (!foundSummary) {
                foundSummary = {
                    plan: planFromQuery || selectedPlan?.name || planName,
                    amountPaid: formatAmount(amountFromQuery) || planAmount,
                    billing: combined.get('billing') || 'Monthly',
                };
            } else {
                // If a saved summary exists but backend provided nicer display
                // values, prefer those.
                if (planFromQuery) foundSummary.plan = planFromQuery;
                if (amountFromQuery) foundSummary.amountPaid = formatAmount(amountFromQuery);
                if (combined.get('billing')) foundSummary.billing = combined.get('billing');
            }

            setSuccessSummary(foundSummary);

            try {
                localStorage.setItem("hasPaidPlan", "true");
            } catch {}

            // setShowSuccessModal(true);
            handleShowSuccessModal();
            // Auto-login the user after successful payment
            void autoLoginUser({ redirectToDashboard: true });
        } else if (isFailedFromRedirect) {
            localStorage.removeItem("pendingPaymentSummary");
            setShowDeclinedModal(true);
        }
    }, [location.search, location.hash]);

    // Load user's auto-generated wallet account details from localStorage
    // Dummy data: skip loading from localStorage for now
    // useEffect(() => {
    //     ...existing code...
    // }, []);

    // Function to auto-login user after successful payment
    const autoLoginUser = async ({ redirectToDashboard } = { redirectToDashboard: false }) => {
        try {
            const userEmail = localStorage.getItem("userEmail");
            const userPassword = localStorage.getItem("userPassword");

            if (!userEmail || !userPassword) {
                console.warn("User credentials not found in localStorage for auto-login");
                return;
            }

            const response = await axios.post(`${BASE_URL}/v1/login`, {
                email: userEmail,
                password: userPassword,
            });

            if (response.data?.status === true || response.data?.success === true) {
                const token = response.data?.data?.token || response.data?.token;
                const userData = response.data?.data?.user || response.data?.user;

                if (token && userData) {
                    // Use the login function from UserContext
                    login(userData, token);

                    // Fetch companies and pick one so dashboard requests have company_id
                    try {
                        // Clear any previous company data to avoid conflicts
                        localStorage.removeItem('company_id');
                        localStorage.removeItem('activeCompanyId');
                        localStorage.removeItem('companyInfo');
                        localStorage.removeItem('companies');
                        delete axios.defaults.headers.common['company_id'];

                        const compRes = await axios.get(`${BASE_URL}/v1/companies/get-info`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                Accept: "application/json",
                            },
                        });
                        const list = Array.isArray(compRes?.data?.data)
                            ? compRes.data.data
                            : (compRes?.data?.data ? [compRes.data.data] : []);
                        try { localStorage.setItem('companies', JSON.stringify(list)); } catch {}

                        const first = list?.[0] || null;
                        const cid = first?.company_id || first?.id || first?.companyId || null;
                        if (cid && typeof setActiveCompany === 'function') {
                            setActiveCompany(String(cid), first);
                        } else if (cid) {
                            try { localStorage.setItem('company_id', String(cid)); } catch {}
                            try { localStorage.setItem('activeCompanyId', String(cid)); } catch {}
                            try { localStorage.setItem('companyInfo', JSON.stringify(first)); } catch {}
                            try { axios.defaults.headers.common['company_id'] = String(cid); } catch {}
                        }
                    } catch (e) {
                        // If this fails, user is still logged in; dashboard may still work depending on endpoints.
                        console.warn("Failed to fetch/set company after auto-login:", e);
                    }

                    // Clear stored credentials (we only needed them for one-time auto-login)
                    try {
                        localStorage.removeItem("userPassword");
                        localStorage.removeItem("userEmail");
                        localStorage.removeItem("userNIN");
                    } catch {}

                    console.log("User auto-logged in after payment");
                    if (redirectToDashboard) {
                        navigate("/dashboard", { replace: true });
                    }
                } else {
                    console.warn("Login response missing token or user data");
                }
            } else {
                console.warn("Auto-login failed:", response.data?.message);
            }
        } catch (error) {
            console.error("Error during auto-login:", error);
        }
    };

    const handleShowFunction = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };




    const handlePaystackClick = async (e) => {
        e.preventDefault();

        if (paymentMethod === "wallet") {
            // Handle wallet payment
            const amountToPay = parseFloat(planAmount.replace(/[^0-9.-]+/g, ''));
            if (isNaN(amountToPay)) {
                Swal.fire("Error", "Invalid plan amount.", "error");
                return;
            }

            if (walletBalance < amountToPay) {
                Swal.fire("Insufficient Balance", "Your wallet balance is not enough to complete this payment.", "error");
                return;
            }

            // Deduct from wallet
            const newBalance = walletBalance - amountToPay;
            setWalletBalance(newBalance);
            localStorage.setItem("walletBalance", newBalance.toString());

            // Set success summary
            const summary = {
                plan: selectedPlan?.name || planName,
                amountPaid: planAmount,
                billing: "Monthly",
            };
            setSuccessSummary(summary);

            try {
                localStorage.setItem("hasPaidPlan", "true");
            } catch {}

            // setShowSuccessModal(true);
            handleShowSuccessModal();
            // Auto-login the user after successful payment
            void autoLoginUser({ redirectToDashboard: true });
            return;
        }

        // Ensure Paystack is selected as the payment method
        if (paymentMethod !== "paystack") {
            Swal.fire("Payment Method", "Please select 'Pay with Paystack' to continue.", "warning");
            return;
        }

        // Try multiple token sources: authToken, token, or from location state
        const token = 
            localStorage.getItem("authToken") || 
            localStorage.getItem("token") ||
            location.state?.token;
        
        if (!token) {
            console.error("Authentication token not found. Available localStorage keys:", Object.keys(localStorage));
            Swal.fire("Not Logged In", "You must be logged in to make a payment. Please complete company registration first.", "error");
            return;
        }
        
        console.log("Using token for payment authentication");

        // Show processing modal immediately
        setShowPaystackModal(true);
        const startTime = Date.now();

        try {
            const payload = {
                plan_id: selectedPlan?.id,
                plan_name: selectedPlan?.name,
            };

            const res = await axios.post(`${BASE_URL}/v1/pay-package`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            const data = res?.data || {};
            const isSuccess = data?.status === true || data?.success === true;
            const backendMessage =
                (typeof data?.message === "string" && data.message) ||
                (typeof data?.msg === "string" && data.msg) ||
                "";
            const checkoutUrl = typeof data?.data === "string" ? data.data : "";

            const minProcessingTime = 2000; // 2s
            const elapsed = Date.now() - startTime;
            if (elapsed < minProcessingTime) {
                await new Promise((resolve) => setTimeout(resolve, minProcessingTime - elapsed));
            }

            if (isSuccess) {
                if (!checkoutUrl) {
                    setShowPaystackModal(false);
                    await Swal.fire(
                        "Payment Initialization Failed",
                        backendMessage || "No checkout link was returned. Please try again.",
                        "error"
                    );
                    return;
                }

                // Persist summary so we can show it after Paystack redirects back.
                try {
                    localStorage.setItem(
                        "pendingPaymentSummary",
                        JSON.stringify({
                            plan: selectedPlan?.name || planName,
                            amountPaid: planAmount,
                            billing: "Monthly",
                        })
                    );
                } catch {
                    // ignore
                }

                // Redirect user to Paystack checkout.
                window.location.assign(checkoutUrl);
            } else {
                setShowPaystackModal(false);
                await Swal.fire(
                    "Payment Failed",
                    backendMessage || "Payment could not be completed. Please try again.",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error initiating Paystack package payment:", error);
            const errMsg =
                error?.response?.data?.message ||
                error?.response?.data?.msg ||
                error?.message ||
                "Failed to initiate payment. Please try again.";
            await Swal.fire("Error", errMsg, "error");
        } finally {
            // Ensure processing modal is closed in case of early failures
            setShowPaystackModal(false);
        }
    };

const totalAmountDebit = useMemo(() => {
    return rows
        .filter((row) => Number(row.accountCode) === 1)
        .reduce((sum, row) => {
            return sum + Number(row.credit || 0);
        }, 0)
        .toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
}, [rows]);

const totalAmountCredit = useMemo(() => {
    return rows
        .filter((row) => Number(row.accountCode) === 2)
        .reduce((sum, row) => {
            return sum + Number(row.credit || 0);
        }, 0)
        .toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
}, [rows]);


    return (
        <div>
            <div className={classes.vitchri}>
                <div>
                    <img src={promix} />
                </div>

                <div className={classes.busy}>
                    <p className={classes.gate}>Features</p>
                    <p className={classes.gate}>Pricing</p>
                    <p className={classes.gate}>Resources</p>

                    <button className={classes.bu_tton}>Start Free Trial</button>
                </div>
            </div>

            <div className={classes.pirates}>
           Enter Your Opening Balances
            </div>

            <p className={classes.shipManual}>Enter the closing balance from your last financial period for each account. <br /> 
            Leave it blank if the account had no balance at the time</p>

            <div className={classes.topHeader}>
                <div className={classes.leftTopHeader}>
                    <h5>TOTAL DEBITS</h5>  
                    <h1>₦{totalAmountDebit}</h1>
                </div>
                <div className={classes.rightTopHeader}>
                    <h5>TOTAL CREDITS</h5>  
                    <h1>₦{totalAmountCredit}</h1>
                </div>
            </div>
            <div className={classes.topHeaderNew}>
                <div className={classes.leftTopHeader}>
                    <span>Transaction Date: </span>
                    <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    required
                    />
                </div>
                <div className={classes.rightTopHeader}>
                </div>
            </div>
            <div style={{ padding: '10px 20px', maxWidth: '900px', margin: '0 auto' }}>
                <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '30px', backgroundColor: '#fff' }}>
                    <Form className={classes.compactForm}>
                    <div className={classes.tableScrollWrapper}>
                        <table className={classes.tableConfirmOpening}>
                            <thead>
                                <tr style={{ height: "50px" }}>
                                    <th>#</th>
                                    <th>ACCOUNT NAME</th>
                                    <th>ACCOUNT TYPE</th>
                                    <th>CREDIT/DEBIT</th>
                                    <th>OPENING BALANCE (₦)</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {accountsLoading ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center", padding: "40px" }}>
                                    <div className={classes.spinnerWrapper}><div className={classes.spinner}></div></div>
                                    </td>
                                </tr>
                                ) : rows.length === 0 ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
                                    No rows available.
                                    </td>
                                </tr>
                                ) : (
                                rows.map((row, index) => (
                                    <tr key={index}>
                                    <td style={{fontSize:"13px"}} >{index + 1}</td>
                                        <td>
                                            <input
                                            type="text"
                                            className={classes.debitInput}
                                            value={row.accountName}
                                            onChange={(e) => handleChange(index, "accountName", e.target.value)}
                                            placeholder="Enter Account Name"
                                            readOnly
                                            // disabled={row.isPrefilled}
                                            // disabled={row.accountName && parseFloat(row.accountName) > 0}
                                            />
                                        </td>
                                        <td>
                                            <input
                                            type="text"
                                            className={classes.debitInput}
                                            value={row.description}
                                            onChange={(e) => handleChange(index, "description", e.target.value)}
                                            readOnly
                                            />
                                        </td>
                                        <td>
                                        <select
                                            id="accountType"
                                            className={classes.formSelect}
                                            value={row.accountCode}
                                            onChange={(e) => handleChange(index, "accountCode", e.target.value)}
                                        >
                                            <option value="" disabled>
                                            Select Type
                                            </option>

                                            <option value="1">Debit</option>
                                            <option value="2">Credit</option>
                                        </select>
                                        </td>
                                    <td>
                                        <input
                                        type="number"
                                        className={classes.debitInput}
                                        style={{ textAlign: "right" }}
                                        value={row.credit}
                                        onChange={(e) => handleChange(index, "credit", e.target.value)}
                                        placeholder="0.00"
                                        // disabled={row.isPrefilled}
                                        />
                                    </td>
                                    <td>
                                        <img
                                        src={deletes}
                                        alt="Delete"
                                        onClick={() => removeRow(index)}
                                        style={{
                                            cursor: "pointer",
                                            width: "50%",
                                        }}
                                        />
                                        {/* <button  className={classes.removeBtn}>Remove</button> */}
                                    </td>
                                    </tr>
                                ))
                                )}
                            </tbody>

                        </table>

                    </div>
                </Form>
                
                {/* <button
                    className={classes.customAddBtn}
                    onClick={addLine}
                    style={{ marginTop: '20px' }}
                >
                    + Add Account
                </button> */}

                <div style={{ marginTop: '30px', display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                    <p className={classes.previewUpload}>Showing 10 accounts from your uploaded file</p>
                    <div style={{  display: 'flex', gap: '10px'}}>
                        <button
                            className={classes.reuploadBtn}
                            onClick={() => navigate('/upload-opening-bal')}
                        >
                           Cancel
                        </button>
                        <button
                            className={classes.SaveUploadbtn}
                            onClick={saveNewAccounts}
                            disabled={savingAccountsLoading}
                        >   
                        {savingAccountsLoading ? (                                                            
                            <>
                                <Spinner animation="border" size="sm" /> 
                                <span style={{ marginLeft: "5px" }}>Processing...</span>
                            </>
                            ) : (
                                "Save & Continue to Dashboard" 
                        )}
                        </button>
                    </div>
                </div>
                </div>               
            </div>
        </div>

    )
}

export default ManualOpeningBal;
